<h1 mat-dialog-title class="p-2 text-center" i18n>Ajout d'un groupe de tests </h1>
<div mat-dialog-content class="p-3">

    <div class="row align-items-center">
        <mat-form-field class="col-6">
            <input matInput [(ngModel)]="Model.Code" i18n-placeholder placeholder="Code" disabled="">
        </mat-form-field>

        <mat-form-field class="col-6">
            <input matInput [(ngModel)]="Model.Name" i18n-placeholder placeholder="Name" required>
        </mat-form-field>
    </div>

    <div class="row align-items-center">
        <div class="col-auto my-3">
            <mat-slide-toggle  [(ngModel)]="Model.IsDefault" [disabled]="!CanUseIsDefault" i18n>Défaut</mat-slide-toggle>
        </div>
        <div class="col-auto my-3">
            <mat-slide-toggle  [(ngModel)]="Model.IsHidden" [disabled]="!CanUseIsHidden" i18n>Masqué</mat-slide-toggle>
        </div>
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()" i18n>
            Annuler
        </button>
        <button  appPreventDoubleClick class="col ms-1 white" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()" i18n>
            {{ IsCreation ? 'Ajouter' : 'Modifier' }}
        </button>
    </div>
</div>